import React from "react";
import Grow from "@mui/material/Grow";
import { Backdrop, Box, Button, Typography } from "@mui/material";

interface Props {
    children?: React.ReactNode;
    open: boolean;
    canceled: Function;
    confirmed: Function;
}

export default function AskForConfirmation(props: Props){
    const { children, confirmed, canceled, open } = props

  return (
    <Backdrop sx={{ backgroundColor: "#grey", zIndex: 1200 }} open={open} onClick={() => canceled()}>
        <Grow in={true} style={{transform: "translate(-50%, -50%)"}}>
            <Box sx={{
                    width: "30%", 
                    minWidth: "300px",
                    maxWidth: "90%",
                    position: "absolute", 
                    top: "50%", 
                    left: "50%",
                    backgroundColor: "white",
                    transform: "translate(-50%, -50%)",
                    borderRadius: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    padding: 4,
                    textAlign: "center",
                }}>
                <Box>
                    <Typography fontSize={20} fontWeight={"bold"}>
                        {children}
                    </Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1}}>
                    <Button
                        onClick={() => {
                            canceled();
                        }}
                        sx={{
                            flexGrow: 1,
                            borderRadius: "26px",
                            color: "#072D26",
                            fontWeight: "bold",
                            border: "2px solid #C0D904",
                            height: "51px",
                            paddingLeft: "50px", 
                            paddingRight: "50px",
                            "&:hover": { background: "#c0d904" }
                    }}>
                        Abbrechen
                    </Button>
                    <Button
                        onClick={() => {
                            confirmed();
                        }}
                        sx={{
                            flexGrow: 1,
                            borderRadius: "26px",
                            color: "#072D26",
                            fontWeight: "bold",
                            border: "2px solid #C0D904",
                            height: "51px",
                            paddingLeft: "50px", 
                            paddingRight: "50px",
                            "&:hover": { background: "#c0d904" }
                            }}
                        >
                        Bestätigen
                    </Button>
                </Box>
            </Box>
        </Grow>
    </Backdrop>
  )
};